import { Rating, Stack, Typography } from '@mui/material';
import React from 'react';
import { Controller, Path, useFormContext } from 'react-hook-form';
import { ReviewFormValues } from '../types';

interface StarRatingFieldProps {
    name: Path<ReviewFormValues>;
    captions?: string[];
}

const StarRatingField: React.FC<StarRatingFieldProps> = ({
    name,
    captions,
}) => {
    const { control } = useFormContext<ReviewFormValues>();

    const defaultCaptions = ['Terrible', 'Bad', 'Ok', 'Good', 'Great'];

    return (
        <Controller
            key={name as string}
            control={control}
            name={name}
            render={({ field, fieldState }) => {
                const currentValue =
                    typeof field.value === 'number' ? field.value : 0;
                const labelsToUse = captions || defaultCaptions;
                const currentCaption =
                    currentValue > 0 ? labelsToUse[currentValue - 1] : '';

                return (
                    <Stack spacing={1}>
                        <Rating
                            name={field.name}
                            value={currentValue}
                            onChange={(_, v) => {
                                if (v && v > 0) {
                                    field.onChange(v);
                                }
                            }}
                            onBlur={field.onBlur}
                            ref={field.ref}
                            precision={1}
                            sx={{
                                fontSize: '70px',
                                stroke: 'white',
                                '& .MuiRating-icon': {
                                    marginRight: '-8px',
                                },
                            }}
                        />

                        {currentCaption && (
                            <Typography
                                sx={{
                                    color: 'text.primary',
                                    paddingLeft: 1,
                                    paddingBottom: 0.5,
                                    paddingTop: 0.5,
                                    fontSize: '13px',
                                    fontWeight: 'bold',
                                }}
                            >
                                {currentCaption}
                            </Typography>
                        )}
                    </Stack>
                );
            }}
        />
    );
};

export default StarRatingField;
